import { render, staticRenderFns } from "./FileFolderIcon.vue?vue&type=template&id=222b0dc2&"
import script from "./FileFolderIcon.vue?vue&type=script&lang=js&"
export * from "./FileFolderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports